module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "crt",
    attrs: {
      "id": "d12e133"
    }
  }, [_c('b', [_vm._v("ZONDERVAN")])]), _vm._v(" "), _c('p', {
    staticClass: "crt",
    attrs: {
      "id": "d12e135"
    }
  }, [_c('i', [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EARLS OF")]), _vm._v(" G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("REAT ")]), _vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RICE")])])]), _vm._v(" "), _c('p', {
    staticClass: "crt",
    attrs: {
      "id": "d12e138"
    }
  }, [_vm._v("Copyright © 2006 by Joni Eareckson Tada")]), _vm._v(" "), _c('p', {
    staticClass: "crt",
    attrs: {
      "id": "d12e140"
    }
  }, [_vm._v("All rights reserved under International and Pan-American Copyright Conventions. By payment of the required fees, you have been granted the non-exclusive, non-transferable right to access and read the text of this e-book on-screen.  No part of this text may be reproduced, transmitted, down-loaded, decompiled, reverse engineered, or stored in or introduced into any information storage and retrieval system, in any form or by any means, whether electronic or mechanical, now known or hereinafter invented, without the express written permission of Zondervan.")]), _vm._v(" "), _c('p', {
    staticClass: "crt",
    attrs: {
      "id": "d12e142"
    }
  }, [_vm._v("ePub Edition January 2009 ISBN: 978-0-310-29786-4")]), _vm._v(" "), _c('p', {
    staticClass: "crt",
    attrs: {
      "id": "d12e144"
    }
  }, [_vm._v("Requests for information should be addressed to:")]), _vm._v(" "), _c('p', {
    staticClass: "crt",
    attrs: {
      "id": "d12e146"
    }
  }, [_vm._v("Zondervan, "), _c('i', [_vm._v("Grand Rapids, Michigan 49530")])]), _vm._v(" "), _c('hr'), _c('p', {
    staticClass: "crt",
    attrs: {
      "id": "d12e151"
    }
  }, [_vm._v("Library of Congress Cataloging-in-Publication Data")]), _vm._v(" "), _c('p', {
    staticClass: "crt",
    attrs: {
      "id": "d12e153"
    }
  }, [_vm._v("Tada, Joni Eareckson.")]), _vm._v(" "), _c('p', {
    staticClass: "crt",
    attrs: {
      "id": "d12e155"
    }
  }, [_vm._v("Pearls of great price : 366 daily devotional readings / Joni Eareckson Tada.")]), _vm._v(" "), _c('p', {
    staticClass: "crt",
    attrs: {
      "id": "d12e158"
    }
  }, [_vm._v("p. cm.")]), _vm._v(" "), _c('p', {
    staticClass: "crt",
    attrs: {
      "id": "d12e160"
    }
  }, [_vm._v("Includes index.")]), _vm._v(" "), _c('p', {
    staticClass: "crt",
    attrs: {
      "id": "d12e162"
    }
  }, [_vm._v("ISBN: 978-0-310-26298-5")]), _vm._v(" "), _c('p', {
    staticClass: "crt",
    attrs: {
      "id": "d12e164"
    }
  }, [_vm._v("1. Devotional calendars. I. Title.")]), _vm._v(" "), _c('p', {
    staticClass: "crt",
    attrs: {
      "id": "d12e166"
    }
  }, [_vm._v("BV4811.T355 2006")]), _vm._v(" "), _c('p', {
    staticClass: "crt",
    attrs: {
      "id": "d12e168"
    }
  }, [_vm._v("242'.2–dc22")]), _vm._v(" "), _c('p', {
    staticClass: "crtr",
    attrs: {
      "id": "d12e170"
    }
  }, [_vm._v("2006024638")]), _vm._v(" "), _c('hr'), _c('p', {
    staticClass: "crt",
    attrs: {
      "id": "d12e173"
    }
  }, [_vm._v("All Scripture quotations, unless otherwise indicated, are taken from the "), _c('i', [_vm._v("Holy Bible, New ")]), _c('i', [_vm._v("International Version")]), _c('sup', [_vm._v("®")]), _vm._v(". NIV"), _c('sup', [_vm._v("®")]), _vm._v(". Copyright © 1973, 1978, 1984 by International Bible Society. Used by permission of Zondervan. All rights reserved.")]), _vm._v(" "), _c('p', {
    staticClass: "crt",
    attrs: {
      "id": "d12e180"
    }
  }, [_vm._v("Internet addresses (websites, blogs, etc. and telephone numbers printed in this book are offered as a resource to you. These are not intended in any way to be or imply an endorsement on the part of Zondervan, nor do we vouch for the content of these sites and numbers for the life of this book.")]), _vm._v(" "), _c('p', {
    staticClass: "crt",
    attrs: {
      "id": "d12e182"
    }
  }, [_vm._v("All rights reserved. No part of this publication may be reproduced, stored in a retrieval system, or transmitted in any form or by any means — electronic, mechanical, photocopy, recording, or any other — except for brief quotations in printed reviews, without the prior permission of the publisher.")]), _vm._v(" "), _c('p', {
    staticClass: "crt",
    attrs: {
      "id": "d12e185"
    }
  }, [_vm._v("Published in association with the literary agency of Wolgemuth and Associates, Inc.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9f4db9da","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Tada_9780310297864_epub_c4_r1.vue
// module id = 66
// module chunks = 0